import { supabase } from '@/lib/supabase';
import type { Database } from '@/types/supabase';
import type { User as AuthUser } from '@supabase/supabase-js';
import type { User } from './User';
import type { Account } from './Account';

export type AccountUser = Database['public']['Tables']['account_users']['Row'] & {
  auth_user?: AuthUser;
  user?: User;
  account?: Account;
};
type AccountUserInsert = Database['public']['Tables']['account_users']['Insert'];
type AccountUserUpdate = Database['public']['Tables']['account_users']['Update'];

export class AccountUserService {
  static async filter(query: Partial<AccountUser>): Promise<AccountUser[]> {
    // Buscar vínculos de conta
    let queryBuilder = supabase.from('account_users').select('*');

    Object.entries(query).forEach(([key, value]) => {
      if (value !== undefined) {
        queryBuilder = queryBuilder.eq(key, value);
      }
    });

    console.log('AccountUser.filter - Query:', query);
    const { data, error } = await queryBuilder;
    console.log('AccountUser.filter - Result:', { data, error });

    if (error) {
      console.error('AccountUser.filter - Error:', error);
      throw error;
    }

    return data || [];
  }


}

// Re-export para manter compatibilidade com código existente
export const AccountUser = AccountUserService;
